module.exports = __webpack_public_path__ + "static/media/microbit-batt.923fee8d.gif";